import { newDate, PermissionService, validInt } from 'booksprout'
import state from './state'

/**
 * Plain ES getters, evaluated on access. Carried over from the Vuex getters unchanged, including
 * two behaviours worth naming because they look like bugs otherwise:
 *
 * - `authenticatedUser` / `mimicUser` build a fresh PermissionService on *every* read. That is
 *   how the Vuex versions behaved and templates lean on it, so it is preserved rather than
 *   memoised. If it ever shows up in a profile, the fix is a cache keyed on the user id, not a
 *   change of shape.
 * - both can return `null`, and callers rely on that: CommonAuthUserMixin substitutes a dummy
 *   user when they do.
 *
 * The Vuex getter `getIsAuthExpired` is spelled `isAuthExpired` here; the Vuex façade keeps the
 * old name pointing at this one.
 */
export default {
  get isAuthenticated () {
    const s = state()

    return !!s.user?.id && !!s.token.expires && s.token.expires > newDate().getTime() / 1000
  },

  get authToken () {
    return state().token.data
  },

  get authenticatedUser () {
    const user = state().user
    if (user === null) {
      return null
    }

    return {
      ...user,
      permissionQuery: new PermissionService().configure(user)
    }
  },

  get mimicUser () {
    const mimicUser = state().mimicUser
    if (!validInt(mimicUser?.id)) {
      return null
    }

    return {
      ...mimicUser,
      permissionQuery: new PermissionService().configure(mimicUser)
    }
  },

  get termsConsentNeeded () {
    return state().termsConsentNeeded
  },

  get termsConsentFailed () {
    return state().termsConsentFailed
  },

  get termsConsentData () {
    return state().termsConsentData
  },

  get csrfToken () {
    return state().csrfToken
  },

  get isAuthExpired () {
    return state().authExpired
  }
}
